var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.853,
    height: 24.585,
    viewBox: "0 0 18.853 24.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 18.853,
    height: 24.585,
    fill: "#0082ca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5318",
    "data-name": "Path 5318",
    d: "M11.146,10.593a5.436,5.436,0,1,0-3.439,0A9.43,9.43,0,0,0,0,19.862c0,1.367,1.1,2.576,2.882,3.424a15.622,15.622,0,0,0,6.544,1.3,15.623,15.623,0,0,0,6.545-1.3c1.781-.849,2.882-2.057,2.882-3.424a9.431,9.431,0,0,0-7.707-9.27",
    transform: "translate(0 0)",
    fill: "#0082ca",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIcon);
export default __webpack_public_path__ + "static/media/profile-user-icon.f091a93365af7caef37d96ad0b444cb9.svg";
export { ForwardRef as ReactComponent };